





















import { Component, Vue } from "vue-property-decorator";
import PageApiAgent from "../../services/page-api-agent";
import CardMenu from "../../components/CardMenu.vue";
import { CardMenuItem } from "../../interfaces/card-menu.interface";
import TranslationApiAgent from "../../services/translation-api-agent";
import Editor from '../../components/Editor.vue';

// @ts-ignore
@Component({
//@ts-ignore
  components: {
	  'ovi-editor': Editor
	}
})
export default class AdminPageEdit extends Vue {
	private activeStr: string = this.translationsApiAgent.get('active');
	private sendStr: string = this.translationsApiAgent.get('send');
	private titleStr: string = this.translationsApiAgent.get('admin::page::title');
	private response: string = '';

	private pages: CardMenuItem[] = [];
	private title: string = '';
	private text: string = '';
	private isActive: boolean = false;

  constructor(
    private pageApiAgent = PageApiAgent,
		private translationsApiAgent = TranslationApiAgent
  ) {
    super();
	}

	get id() {
		return this.$route.params.id;
	}
	
	get isNew() {
		return this.id === 'new';
	}

  mounted() {
		if (!this.isNew) {
			this.pageApiAgent.getById(this.id).then(result => {
				this.text = result.content;
				this.isActive = result.aktiv;
				this.title = result.title;
			});
		}
	}

	private remove() {
		const answer = confirm(this.translationsApiAgent.get('admin::remove-question'));
		if (answer) {
			this.pageApiAgent.remove(this.id).then(result => {
				this.$router.push({
					path: '/admin/pages'
				});
			});
		}
	}

	private send() {
		if (this.isNew) {
			this.pageApiAgent.add(this.title, this.isActive, this.text).then(result => {
				if (result) {
					this.$router.push({
						path: '/admin/pages/' + result.result
					});
				}
			});
		}
		else {
			this.pageApiAgent.update(this.id, this.title, this.isActive, this.text).then(result => {
				this.response = this.translationsApiAgent.get(result ? 'admin::save-success' : 'admin::save-fail');
			});
		}
	}
}
